export default __webpack_public_path__ + "static/fa-light-300-5f6edb43a2fd0bf491099bfac5381dac.ttf";